var _defs, _path, _path2, _path3, _path4, _path5, _path6, _rect, _line;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolPack381({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#fff;stroke-linejoin:round;stroke-width:0.41px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M5,.87A4.79,4.79,0,0,1,10.37,6.2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M5,1.77A3.88,3.88,0,0,1,9.47,6.26"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M10.37,6.2A4.79,4.79,0,0,0,5,.87"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M9.47,6.26A3.88,3.88,0,0,0,5,1.77"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M4.93,2.66A3,3,0,0,1,8.58,6.31"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M8.58,6.31A3,3,0,0,0,4.93,2.66"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 0.69,
    y: 9.44,
    width: 14.63,
    height: 5.72
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 3.54,
    y1: 4.29,
    x2: 3.54,
    y2: 9.29
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolPack381);
export default __webpack_public_path__ + "static/media/Symbol_pack_381.dad164e6678d2f3e217cee088da90507.svg";
export { ForwardRef as ReactComponent };